import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { TDataLinkProps } from "../../Types";
import Et3Button from "../et3-button";

const ET3DataLink = withLiteObserverAndTheme<TDataLinkProps>((props) => {
  const { name, onPress, type, theme } = props;
  const { colors, getFontSize, getFontType } = theme;

  return type === "button" ? (
    <Et3Button
      onClick={() => onPress()}
      isEnabled={true}
      type="APPROVE"
      size="MEDIUM"
      text={name}
    />
  ) : (
    <div
      className="clickable"
      onClick={() => onPress()}
      style={{
        color: colors.all.blue,
        fontFamily: getFontType("BOLD"),
        fontSize: getFontSize(20),
        whiteSpace: "nowrap"
      }}
    >
      {i18n.get(name)}
    </div>
  );
});
export default ET3DataLink;
